export default "__VITE_PUBLIC_ASSET__aa87f9c8__"